module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "badge",
    class: _vm.classes
  }, [_c('div', {
    class: {
      badge__icon: true, 'badge__icon--no-backface': _vm.noBackface
    }
  }, [_vm._t("front", [_c('sk-icon', {
    class: _vm.icon
  })]), _vm._v(" "), (!_vm.noBackface) ? _c('span', {
    staticClass: "badge__back"
  }, [_vm._t("back", [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Redeem now")])])], 2) : _vm._e()], 2), _vm._v(" "), _c('h6', {
    staticClass: "badge__points"
  }, [_vm._t("points")], 2), _vm._v(" "), _c('p', {
    staticClass: "badge__text"
  }, [_vm._t("text")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-439d6844","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/badge/badge.vue
// module id = 895
// module chunks = 0